import script from "./judicativeResult.vue?vue&type=script&setup=true&lang=js"
export * from "./judicativeResult.vue?vue&type=script&setup=true&lang=js"

import "./judicativeResult.vue?vue&type=style&index=0&id=661a520d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661a520d"]])

export default __exports__